import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export const MySelectedProductCats = ({ items }) => {
  if (!items || items.length === 0) return null;

  // Helper getters to safely handle property variations
  const getMainCategory = (item) => {
    if (typeof item === "string") return item;
    return item.MainCategory || item.mainCat || item.mainCategory || "";
  };

  const getCategory = (item) => {
    if (typeof item === "string") return "";
    return item.Category || item.subCat || item.category || "";
  };

  const getSubCategory = (item) => {
    if (typeof item === "string") return "";
    return item.SubCategory || item.subSubCat || item.subCategory || "";
  };

  const getDisplayLabel = (item) => {
    if (typeof item === "string") return item;
    return (
      getSubCategory(item) ||
      getCategory(item) ||
      getMainCategory(item) ||
      "Category"
    );
  };

  // Check if items are flat strings or single-level main categories only
  const firstItem = items[0];
  const isSimpleList =
    typeof firstItem === "string" ||
    (!getCategory(firstItem) && !getSubCategory(firstItem));

  if (isSimpleList) {
    return (
      <Box display="flex" flexWrap="wrap" gap={1}>
        {items.map((item, index) => (
          <Chip
            key={index}
            label={getMainCategory(item) || getDisplayLabel(item)}
            variant="outlined"
            size="small"
            color="primary"
            sx={{ borderRadius: "8px", fontWeight: 600 }}
          />
        ))}
      </Box>
    );
  }

  // Grouped display for nested categories
  const groupedItems = items.reduce((acc, item) => {
    const mainCategory = getMainCategory(item) || "General";
    if (!acc[mainCategory]) {
      acc[mainCategory] = [];
    }
    acc[mainCategory].push(item);
    return acc;
  }, {});

  return (
    <Box>
      {Object.entries(groupedItems).map(([mainCategory, itemsInGroup]) => (
        <Box
          key={mainCategory}
          mb={1.5}
          p={1.5}
          border="1px solid #e2e8f0"
          borderRadius="10px"
          bgcolor="#f8fafc"
        >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            color="#1e293b"
            gutterBottom
          >
            {mainCategory}
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {itemsInGroup.map((item, index) => (
              <Chip
                key={index}
                label={getDisplayLabel(item)}
                variant="outlined"
                size="small"
                color="primary"
                sx={{ borderRadius: "8px", fontWeight: 600, bgcolor: "#ffffff" }}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
